const TEXT = {
    HEADING: "ESIM",
    SUB_HEADING: "Her installerer du dine bestilte eSIM",
    SUB_HEADING_B2B: "Her installerer du dine bestilte eSIM, eller videresende de til en epost-adresse",
    NO_ADMIN_NUMBERS_INFO:
        "Vi finner ingen registrerte bedriftsadministratorer. Man kan opprette en administrator i MinBedrift. Husk at også selve brukeren av abonnementet kan logge inn med sin egen BankId og se QR-koden.",
    BANKID: {
        LOGIN: {
            HEADING: "Logg på",
            PARAGRAPH: "Identifiser deg først med BankID. Deretter får du muligheten til å installere bestilte eSIM.",
        },
    },
    ESIM: {
        ESIM_DESCRIPTION:
            "Du trenger WiFi eller mobildata på den enhet du skal installere eSIM. Etter fullført installering og eventuelt aktivering - så er mobilen klar til bruk.",
        ESIM_DESCRIPTION_NOTE:
            "NB! Du må refreshe denne websiden for å få oppdatert status på installeringen, etter at du har skannet QR-koden.",
        ESIM_HEADING: "Mine eSIM",
        ESIM_SCAN_QR_HEADING: "Skann QR-kode:",
        ESIM_SCAN_QR_PARAGRAPH:
            "Åpne kameraet på enheten du vil installere eSIM og pek på QR-koden. En notifikasjon dukker opp. Trykk på notifikasjonen og følg instruksjonene på telefonen. Hele prosessen tar et par minutter.",
        ESIM_SEND_QR: "Eller videresend QR-koden til en annen: ",
        ESIM_SEND_CONFIRMATION: (email: string) => `eSIM QR-koden har blitt sendt på e-post til ${email}`,
        ESIM_SEND_QR_BUTTON: "Send QR-kode",
        INSTALL_BUTTON: "Installér eSIM",
        INSTALL_STEPS: {
            STEP_ONE: "Installér eSIM",
            STEP_TWO: "Aktivér eSIM",
        },
        INSTALLED_STATUS: {
            INSTALLED: "Installert",
            NOT_INSTALLED: "Ikke installert",
        },
    },
    CONFIRM_NUMBER: {
        HEADING: "Verifiser deg som bedriftsadministrator",
        DESCRIPTION:
            "Du må verifisere deg som bedriftsadministrator for å se alle QR-kode(r) i ordren. Velg ditt telefonnummer og motta en kode på SMS. Deretter vil du få se QR-kode(r) for installering av eSIM som du kan videresende til brukeren.",
        NUMBER_FIELD: {
            LABEL_TEXT: "Mobilnummer til bedriftsadministrator",
            PLACEHOLDER: "Mobilnummer",
        },
    },
    SIM_TYPE: {
        MAIN_SIM: "Hoved-SIM",
        EXTRA_DATA_SIM: "Ekstra DataSIM",
        TWIN_SIM: "TvillingSIM",
        REPLACEMENT_SIM: "Erstatnings-SIM",
        UNKNOWN: "eSIM",
    },
    ERRORS: {
        HEADING: "Obs!",
        ORDER_NOT_FOUND:
            "Denne lenken ser ikke ut til å være gyldig lenger. Prøv en annen nettleser hvis du mener den bør være gyldig.",
        ORDER_HAS_NON_ESIM: "Denne ser ikke ut til å inneholde noen eSIM som må innstalleres.",
        ORDERER_IS_ORGANIZATION:
            "Den som har bestilt denne ordre med eSIM er en bedriftseier, vennligst kontakt vårt kundesenter.",
        INSTALLED_BUT_NOT_ACTIVE: "Alle eSIM i ordren er installert. Men du trenger å aktivere dem på MinSide.",
        ALL_INSTALLED_AND_ACTIVE: "Alle eSIM i ordren er både installert og aktivert.",
    },
} as const;

export default TEXT;
